import { validateBirthDate } from '@/utils/validations'
import z from 'zod'
import { isPhone, isCPF } from '@conexasaude/front-utils'
import { errorMessages } from '@/constants/messages'

export const termsAndConditionsFormSchema = z.object({
  cpf: z
    .string()
    .min(1, errorMessages.REQUIRED_FIELD)
    .refine(isCPF, { message: errorMessages.INVALID_CPF }),
  email: z
    .string()
    .min(1, errorMessages.REQUIRED_FIELD)
    .email(errorMessages.INVALID_EMAIL),
  birthDate: z
    .string()
    .min(1, errorMessages.REQUIRED_FIELD)
    .refine(value => validateBirthDate(value), {
      message: errorMessages.INVALID_BIRTH_DATE,
    }),
  phone: z
    .string()
    .min(1, errorMessages.REQUIRED_FIELD)
    .refine(isPhone, { message: errorMessages.INVALID_PHONE }),
  acceptTerms: z
    .boolean()
    .refine(value => !!value, { message: errorMessages.INVALID_ACCEPT_TERMS }),
})
